/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext } from 'react';
import { Offre } from '../../../providers/OffresProvider';
import { TiersOfferOrigins } from '../hooks';

const offerDataLoaded = false;
const getTiersCurrentOffer = (_tiersId: number): Promise<Offre | undefined> =>
    Promise.resolve(undefined);
const getTiersCurrentOfferWithDefault = (_tiersId: number): Promise<Offre | undefined> =>
    Promise.resolve(undefined);
const setTiersCurrentOffer = (
    _tiersId: number,
    _newOfferId?: number,
): Promise<TiersOfferOrigins | undefined> => Promise.resolve(undefined);

const TiersOfferContext = createContext({
    offerDataLoaded,
    getTiersCurrentOffer,
    getTiersCurrentOfferWithDefault,
    setTiersCurrentOffer,
});

export const useTiersOfferContext = () => useContext(TiersOfferContext);

/** @deprecated use useTiersOfferContext */
export const useOfferContext = useTiersOfferContext;

export default TiersOfferContext;
